module.exports = __webpack_public_path__ + "static/media/012-sao-tome-and-prince.b0884ff8.svg";